import { render, staticRenderFns } from "./manMachine.vue?vue&type=template&id=0680f693&scoped=true&"
import script from "./manMachine.vue?vue&type=script&lang=js&"
export * from "./manMachine.vue?vue&type=script&lang=js&"
import style0 from "./manMachine.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./manMachine.vue?vue&type=style&index=1&id=0680f693&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0680f693",
  null
  
)

export default component.exports